import React from 'react';
import { Fade } from 'react-reveal';
import VisibilitySensor from 'react-visibility-sensor';
import './home.scss';

import { TitleHeader } from '../shared';

const REVEAL_DELAY = 500;
const CASCADE_DURATION = 2000;

const Home = () => {
  return (
    <div className="center-container">
      <TitleHeader title="INTRODUCTION" />
      <Fade
        // bottom
        cascade
        delay={REVEAL_DELAY}
        duration={CASCADE_DURATION}
      >
        <div>
          <div className="sector">
            Hello there.
          </div>
          <div className="sector">
            ...
            nothing quite to see here at this point of time.
          </div>
          <div className="sector black bg-pblue">
            I like things to be simple but good.
            <br />
            So please allow me to spent some time building it.
          </div>
          <div className="sector">
            See you soon.
          </div>
        </div>
      </Fade>
      
    </div>
  );
};

export default Home;
